import { AcceptMethod, ActivityType, ApplicantStatus, BookEventType, CommunityApplicantStatus, CommunityBoardType, CommunityType, MeetingType } from "../common/enums";
import { BookInfoDTO } from "./BookDTOs";
import { UserInfoDTO } from "./UserDTOs";

export class BookcommunityApplicantInfoDTO  {
	
	

	id:number|null = null;
	
	//bookcommunity:BookcommunityInfoDTO|null = null;
	
	//applicant:UserInfoDTO|null = null;

    userId:number|null = null;

	loginid:string|null = null;
	
	name:string|null = null;
	
	email:string|null = null;
	
	profileImgUrl:string|null = null;

	uuid:string|null = null;

	applicantStatus:CommunityApplicantStatus|null = null;
	
	createdAt:Date|null = null;
		
}



export class BookcommunityInfoDTO {

	id:number|null = null;
	
	owner:UserInfoDTO|null = null;
	
	title:string|null = null;
	
	communityType:CommunityType|null = null;

	activityType:ActivityType|null = null;
	
	recruitTo:Date|null = null;
	
	imgUrl:string|null = null;

	imageId:string|null = null;
	
	briefIntroduction:string|null = null;
	
	recruitNum:number|null = null;
	
	acceptMethod:AcceptMethod|null = null;
	
	membershipFee:string|null = null;
	
	paymentInfo:string|null = null;
	
	createdAt:Date|null = null;
	
	hashtags:string[]|null = null;
	
	boards:BookcommunityBoardDTO[]|null = null;
	
	lastBookInfo:BookcommunityBookInfoDTO|null = null;
	
}


export class BookcommunityBoardDTO {
	
	
	id:number|null = null;
	
	boardType:CommunityBoardType|null = null; 
	
	boardName:string|null = null;
	
	boardDesc:string|null = null;
	
	createdAt:Date|null = null;
}

export class BookcommunityBookCommentDTO  {

	id:number|null = null;

	memberId:number|null = null;

	loginid:string|null = null;

	name:string|null = null;

	email:string|null = null;

	profileImgUrl:string|null = null;
	
	bookcommunityBookId:number|null = null;
	
	//member:UserInfoDTO|null = null;
	
	bookComment:string|null = null;
	
	createdAt:Date|null = null;
	
	updatedAt:Date|null = null;
}

export class BookcommunityBookCommentInputReqDTO {
	
	memberId:number|null = null;
	
	bookComment:string|null = null;
}



export class BookcommunityBookInfoDTO  {
	
	id:number|null = null;
	
	bookcommunityId:number|null = null; 

	communityOwnerId:number|null = null;

	communityImgUrl:string|null = null;
	
	book:BookInfoDTO|null = null;
	
	bookIntroduction:string|null = null;

	meetingDate:Date|null = null;

	meetingTime:string|null = null;

	participantNum:number|null = null;

	meeting_type:MeetingType|null = null;

	participationCondition:string|null = null;

	presentationStatement:string|null = null;

	likeCnt:number|null = null;
	
	commentCnt:number|null = null;
	
	createdAt:Date|null = null;
}


export class BookcommunityBookInputReqDTO  {

	
	bookcommunityId:number|null = null; 
	
	bookId:number|null = null;
	
	bookIsbn:string|null = null;

	bookIntroduction:string|null = null;

	meetingDate:Date|null = null;

	meetingTime:string|null = null;

	participantNum:number|null = null;

	meeting_type:MeetingType|null = null;

	participationCondition:string|null = null;

	presentationStatement:string|null = null;
	
	createdAt:Date|null = null;
	
}




export class BookcommunityInputReqDTO {

	//'모임 타이틀'
	title:string|null = null;

	//'모임 종류 
	communityType:CommunityType|null = null;


	//'모임 활동 종류 
	activityType:ActivityType|null = null;

	//'모집기간 종료일'
	recruitTo:Date|null = null;

	
	tmpImageId:string|null = null;
	
	//'이벤트 이미지 ID'
	imageId:string|null = null;
	
	//'간단 소개'
	briefIntroduction:string|null = null;
	
	//'모집 인원'
	recruitNum:number|null = null;
	
	//'승인 방식'
	acceptMethod:AcceptMethod|null = null;
	
	hashtags:string[]|null = null;

	membershipFee:string|null = null;
	
	paymentInfo:string|null = null;
	
}

export class BookcommunitySearchReqDTO {


	//'모임 소유자' 
	ownerName:string|null = null;

	//'모임 타이틀'
	title:string|null = null;

	//'모임 종류 
	communityType:CommunityType|null = null; 

	//'모임 활동 종류 
	activityType:ActivityType|null = null;

	//'모집기간 조회 시작일'
	recruitToFr:Date|null = null;
	
	//'모집기간 조회 종료일'
	recruitToTo:Date|null = null;
	
}

export class BookcommunityBookLikeDTO {
	
	id:number|null = null;
	
	bookcommunityBookId:number|null = null;
	
	memberId:number|null = null;
	
	createdAt:Date|null = null;
	
	
}

export class BookcommunityBoardTextFileDTO {
	
	id:number|null = null;

	fileName:string|null = null;
	
	fileExt:string|null = null;
	
	fileStoreId:string|null = null;
	
	fileUrl:string|null = null;

	fileDownloadUrl:string|null = null;
	
	fileNo:number|null = null;
	
	createdAt:Date|null = null;
	
	updatedAt:Date|null = null;
}


export class BookcommunityBoardTextDTO {
	


	id:number|null = null;
	
	parentId:number|null = null;
	
	communityOwnerId:number|null = null;

	bookcommunityId:number|null = null;
	
	bookcommunityBoardId:number|null = null;
	
	memberId:number|null = null;

	loginid:string|null = null;

	name:string|null = null;

	email:string|null = null;

	profileImgUrl:string|null = null;
	
	boardText:string|null = null;
	
	likeCnt:number|null = 0;  

	commentCnt:number|null = 0;
	
	createdAt:Date|null = null;
	
	updatedAt:Date|null = null;
	
	files:BookcommunityBoardTextFileDTO[]|null = null;
}


export class BookcommunityBoardTextInputReqDTO {
	boardText:string|null = null;
	files:BookcommunityBoardTextFileDTO[]|null = null;
}



export class BookcommunityBoardTextLikeDTO {
	
	id:number|null = null;
	
	bookcommunityId:number|null = null;

	bookcommunityBoardId:number|null = null;

	bookcommunityBoardTextId:number|null = null;
	
	memberId:number|null = null;
	
	createdAt:Date|null = null;
}



export class BookcommunityBoardTextReportDTO {

	id:number|null = null;
	
	bookcommunityId:number|null = null;

	bookcommunityBoardId:number|null = null;

	bookcommunityBoardTextId:number|null = null;
	
	memberId:number|null = null;
	
	bookcommunityBoardTextReport:string|null = null;
	
	createdAt:Date|null = null;
	
}
